module.exports = __webpack_public_path__ + "static/media/parasyte.ec2e2168.jpg";